import { render, staticRenderFns } from "./IsInformBoardModal.vue?vue&type=template&id=4e8e8ece&scoped=true"
import script from "./IsInformBoardModal.vue?vue&type=script&lang=js"
export * from "./IsInformBoardModal.vue?vue&type=script&lang=js"
import style0 from "./IsInformBoardModal.vue?vue&type=style&index=0&id=4e8e8ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8e8ece",
  null
  
)

export default component.exports